import { Injectable } from '@angular/core';
import {LiveTrainingInterface} from '../models/events';
import { CommonapiService } from './commonapi.service';
import * as CryptoJS from 'crypto-js';  

@Injectable({
  providedIn: 'root'
})
export class LivetrainingService {


  public objevents: LiveTrainingInterface[] = new Array();
  public objLiveMeetings: LiveTrainingInterface[] = new Array();
  conversionEncryptOutput: string='';
  encPassword:string='';

  constructor(
    private commonApiService: CommonapiService
  ) { }


  async getEvents() {
    this.objevents = new Array();    
    const _obj = {
      "TrainingCourseName": ""
    };

    let _dt = await this.commonApiService.postData("api/TrainingApi/DBLiveTrainings/", _obj).toPromise();

    

    if (_dt && _dt[0] && _dt[0].dataSet && _dt[0].dataSet.mlTrainingTrackerList && _dt[0].dataSet.mlTrainingTrackerList.length > 0) {
      const _data = _dt[0].dataSet.mlTrainingTrackerList;

      console.log(_data);
      _data.forEach(element => {

        this.conversionEncryptOutput='';
        this.conversionEncryptOutput=CryptoJS.AES.encrypt(element.trainingTrackerID.toString(),this.encPassword);
        this.objevents.push({
          id: element.trainingTrackerID,
          coursename:element.trainingCourseName,
          courseid:0,
          company:element.companyName,
          site:element.siteName,
          datetime:element.trainingDate,
          instructor:element.instructorName,
          link: this.conversionEncryptOutput,
          IsPicturesForCard:element.isPicturesForCard,
          Type:'Training',
          CoursePDF:element.courseMaterialPDFName
        });
      });
    }

    return this.objevents;
  }


  async getLiveMeetings() {
    this.objLiveMeetings = new Array();    
    const _obj = {
      "MeetingTrackerID": 0,
      "MeetingCourseName":null
    };

    let _dt = await this.commonApiService.postData("api/TrainingApi/DBLiveMeetings/", _obj).toPromise();

    if (_dt && _dt[0] && _dt[0].dataSet && _dt[0].dataSet.mlMeetingTrackerList && _dt[0].dataSet.mlMeetingTrackerList.length > 0) {
      const _data = _dt[0].dataSet.mlMeetingTrackerList;

      console.log("getmeetings");
      console.log(_data);

      
      _data.forEach(element => {

        this.conversionEncryptOutput='';
        this.conversionEncryptOutput=CryptoJS.AES.encrypt(element.meetingTrackerID.toString(),this.encPassword);
        this.objLiveMeetings.push({
          id: element.meetingTrackerID,
          coursename:element.meetingCourseName,
          company:element.companyName,
          courseid:element.meetingCourseID,
          site:element.siteName,
          datetime:element.meetingDate,
          instructor:element.instructorName,
          link: this.conversionEncryptOutput,
          IsPicturesForCard:element.isPicturesForCard,
          Type:'Meeting',
          CoursePDF:element.courseMaterialPDFName
        });
      });

      console.log(this.objLiveMeetings);
    }

    return this.objLiveMeetings;
  }

  
}
